import { HEADER_TYPE } from '../../../../../../store/dashboard/auditedFinancials/constants';
import { formatDateByFormat, DATE_FORMATS } from '../../../../../../utils/dateUtils';
import { FinancialMetricsHeader } from '../MetricsKPISidebar/financialMetricsApi';

type AnnualisedHeaderFields = Partial<Pick<FinancialMetricsHeader, 'type' | 'isPartialYear' | 'key'>>;

/**
 * True for a provisional header covering a partial financial year whose values have been
 * annualised (e.g. Apr-Aug scaled to a full year) — the case that needs the "(Annu.)" label
 * and tooltip disclosure instead of the plain provisional "*".
 */
export const isAnnualisedPartialHeader = (header?: AnnualisedHeaderFields | null): boolean =>
    header?.type === HEADER_TYPE.PROVISIONAL_FINANCIALS && header?.isPartialYear === true && !!header?.key;

export const getAnnualisedFyLabel = (header: Partial<Pick<FinancialMetricsHeader, 'key'>>): string => {
    const endYear = String((Number(header.key) + 1) % 100).padStart(2, '0');
    return `FY'${endYear} (Annu.)*`;
};

export const getAnnualisedTooltipText = (dataAvailableTill?: string): string => {
    const monthYear = formatDateByFormat(dataAvailableTill, DATE_FORMATS.MONTH_FULL_YEAR);
    if (!monthYear) return '';
    return `Data is available till ${monthYear}, which has been annualised without scaling to calculate these metrics`;
};
